const navigation = document.querySelector<HTMLDialogElement>('[data-marketing-navigation]')
const trigger = document.querySelector<HTMLButtonElement>('[data-marketing-navigation-open]')

if (navigation && trigger) {
  let wasScrollLocked = false

  const close = () => {
    navigation.close()
    trigger.setAttribute('aria-expanded', 'false')
    document.body.classList.toggle('overflow-hidden', wasScrollLocked)
  }

  trigger.addEventListener('click', () => {
    wasScrollLocked = document.body.classList.contains('overflow-hidden')
    navigation.showModal()
    trigger.setAttribute('aria-expanded', 'true')
    document.body.classList.add('overflow-hidden')
  })

  navigation.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return
      if (event.target.closest('a, button')) {
        close()
      } else if (event.target === navigation) {
        const bounds = navigation.getBoundingClientRect()
        if (event.clientX < bounds.left || event.clientX > bounds.right) close()
      }
    },
    { capture: true }
  )

  navigation.addEventListener('cancel', (event) => {
    event.preventDefault()
    close()
  })

  window.matchMedia('(min-width: 768px)').addEventListener('change', (event) => {
    if (event.matches && navigation.open) close()
  })
}
